import React from "react";

export const ImageColumnFormatter = (cellContent, row, rowIndex, { dIndexName}) => (
    // console.log(dIndexName)
    <span className="d-flex justify-content-start">
        <img src={`${process.env.REACT_APP_UPLOADED_FILE_URL}/${row && row[dIndexName] && row[dIndexName].default}`} alt={row.name} className="level-img" />
    </span>
);
